import { ReactNode } from 'react';

import { ClickableIcon } from '../../../ClickableIcon';
import { IconAlertFilled, IconErrorFilled } from '../../../../icons';
import { StatefulTooltip } from '../../../StatefulTooltip';
import { Cell } from '../../../Cell';
import { ICON_SIZE } from '../../constants';

type MiniGridRowStatusIconProps = {
    kind: 'error' | 'warning';
    title: string | ReactNode;
    dataTestId: string;
};

export function MiniGridRowStatusIcon({ kind, title, dataTestId }: MiniGridRowStatusIconProps) {
    const isError = kind === 'error';

    return (
        <Cell type="Icon" leftPadding={false} isGrowable={false}>
            <StatefulTooltip
                color={isError ? 'error' : 'warning'}
                data-testid={`${dataTestId}.tooltip`}
                title={title}
                trigger="click"
                placement="right"
                maxWidth="480"
                delay={0}
                autoFocusProps={{
                    restoreFocus: false,
                }}
            >
                <ClickableIcon data-testid={dataTestId} clickableAreaSize={ICON_SIZE}>
                    {isError ? (
                        <IconErrorFilled role="main" size={ICON_SIZE} color="red" />
                    ) : (
                        <IconAlertFilled role="main" size={ICON_SIZE} color="yellow" />
                    )}
                </ClickableIcon>
            </StatefulTooltip>
        </Cell>
    );
}
